export const SnackbarConfig = {
  strings: {
    close: $localize`Cerrar`,
  },
  classes: {
    primary: ['style-snackbars', 'primary-snackbar'],
    success: ['style-snackbars', 'success-snackbar'],
    warning: ['style-snackbars', 'warning-snackbar'],
    danger: ['style-snackbars', 'danger-snackbar'],
  },
  durations: {
    primary: 6000,
    success: 9000,
    warning: 9000,
    danger: 15000,
  },
};
